module.exports = __webpack_public_path__ + "assets/bec848afec35c44f34b1153576597562.mp3";